module.exports = require('./cjs/nivo-axes')



// WEBPACK FOOTER //
// ./~/@nivo/axes/index.js